import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionBIPage = ({ path }) => (
  <>
    <Meta
      title="Business Intelligence Services & Solutions | ATC Digital Business Solutions"
      description="We provide Business Intelligence Solutions that help predictive analysis & operational developments. ATC offers comprehensive BI Services & Solutions."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/business-intelligence-banner.jpg"
          title="Business Intelligence. Insights and Predictive Analytics."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Timely and effective decisions are critical. Businesses need the
            insight to identify changes and adapt their approach.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">Outcome-driven Analytics</h2>
                <p className="white-txt">
                  Companies are currently experiencing massive data and tool
                  overload, creating competitive stakes among the latest and
                  greatest battling for the ultimate edge among similar
                  developments. Each tool holds tremendous intelligence and
                  provides fascinating insights. Until recently, traditional
                  data analytics tools were used to execute critical business
                  objectives. Most likely, a single data source made the
                  decision, leaving it prone to failure as only one side of the
                  story was told and while traditional analytics provide past
                  data trends, they don’t predict possible outcomes.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="businessIntelligence"
          flyText="Business Intelligence"
          flyBoxImage="solutions/bi-box.jpg"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Business Intelligence: Leveraging Data
                </h2>
                <p>
                  Business Intelligence, big data, and blockchain are all part
                  of boardroom conversations today, even in enterprises as
                  traditional and complex as banking and financial services,
                  healthcare, and oil and gas. Enterprises are quickly moving on
                  from decisions made by the highest paid person(s) to
                  data-driven decision making. In order to get there, companies
                  need to leverage the power of data.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Predictive Analytics
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Collect</h3>
                        <p>Gain insights from multiple platforms.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Transform</h3>
                        <p>Utilize insights to improve business.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Predictive Modeling</h3>
                        <p>
                          Project change using historical data and statistics.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Results</h3>
                        <p>See impact by making data-driven change.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionBIPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionBIPage;
